export default "__VITE_ASSET__95694339__"